import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEnvelopeGroupRegularIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 32 32",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			d: "M21 14.6q2.1.2 2.3 2.3v8.9q-.2 2-2.2 2.2H9.3q-2.1-.2-2.3-2.2v-9c0-1.2 1-2.2 2.2-2.2zm-4.6 8.6a3 3 0 0 1-2.5 0l-4.6-2.7v5.3H21v-5.3zM9.3 18l5.8 3.4h.2l5.8-3.4v-1H9.3z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", { d: "M26.8 8q2 .2 2.2 2.3v9q-.2 2-2.2 2.1H25v-2.2h1.8V14l-2 1.1q-.4-1-1.5-1.7l3.5-2v-1H15V13h-2.2v-2.7c0-1.2 1-2.2 2.2-2.2z" }),
		/* @__PURE__ */ _jsx("path", { d: "M17 4c1.2 0 2.2 1 2.2 2.2h-14v1l5.5 3.3v2.4q-.5 0-.8-.3L5.2 9.9v7.5q-2-.2-2.2-2.3V6.2q.2-2 2.2-2.2z" })
	]
});
export default SvgEnvelopeGroupRegularIcon;
